import React, { useState, useEffect } from "react";
import SectionKelola from "../../../components/CrudUserSetup/SectionKelola";
import {
  jabatan as jabatanList,
  status as statusList,
  roles as rolesList,
} from "../../../mock/dummyOptions";

const KelolaPengguna = () => {
  const [jabatan, setJabatan] = useState([]);
  const [status, setStatus] = useState([]);
  const [roles, setRoles] = useState([]);

  const mapToOptions = (arr) =>
    arr.map((label) => ({
      id: label.toLowerCase().replace(/\s+/g, "-"),
      label,
    }));

  useEffect(() => {
    const storedJabatan =
      JSON.parse(localStorage.getItem("jabatanOptions")) ||
      mapToOptions(jabatanList);
    const storedStatus =
      JSON.parse(localStorage.getItem("statusOptions")) ||
      mapToOptions(statusList);
    const storedRoles =
      JSON.parse(localStorage.getItem("roleOptions")) ||
      mapToOptions(rolesList);

    setJabatan(storedJabatan);
    setStatus(storedStatus);
    setRoles(storedRoles);
  }, []);

  const updateStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  };

  const handleAdd = (type, value) => {
    const map = {
      jabatan: [jabatan, setJabatan, "jabatanOptions"],
      status: [status, setStatus, "statusOptions"],
      roles: [roles, setRoles, "roleOptions"],
    };
    const [current, setter, key] = map[type];
    const newItem =
      typeof value === "string"
        ? { id: Date.now().toString(), label: value }
        : value;
    const updated = [newItem, ...current];
    setter(updated);
    updateStorage(key, updated);
  };

  const handleDelete = (type, value) => {
    const map = {
      jabatan: [jabatan, setJabatan, "jabatanOptions"],
      status: [status, setStatus, "statusOptions"],
      roles: [roles, setRoles, "roleOptions"],
    };
    const [current, setter, key] = map[type];
    const updated = current.filter((item) => item.label !== value.label);
    setter(updated);
    updateStorage(key, updated);
  };

  const handleEdit = (type, updatedList) => {
    const map = {
      jabatan: [setJabatan, "jabatanOptions"],
      status: [setStatus, "statusOptions"],
      roles: [setRoles, "roleOptions"],
    };
    const [setter, key] = map[type];
    setter(updatedList);
    updateStorage(key, updatedList);
  };

  return (
    <div className="pt-10 pb-10 pl-64 pr-6">
      <h1 className="mb-6 text-2xl font-bold text-green-800">
        Manajemen Pengguna
      </h1>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        <SectionKelola
          title="Jabatan"
          data={jabatan}
          onAdd={(val) => handleAdd("jabatan", val)}
          onDelete={(val) => handleDelete("jabatan", val)}
          onEdit={(updated) => handleEdit("jabatan", updated)}
        />
        <SectionKelola
          title="Status Keanggotaan"
          data={status}
          onAdd={(val) => handleAdd("status", val)}
          onDelete={(val) => handleDelete("status", val)}
          onEdit={(updated) => handleEdit("status", updated)}
        />
        <SectionKelola
          title="Role Pengguna"
          data={roles}
          onAdd={(val) => handleAdd("roles", val)}
          onDelete={(val) => handleDelete("roles", val)}
          onEdit={(updated) => handleEdit("roles", updated)}
        />
      </div>
    </div>
  );
};

export default KelolaPengguna;
